import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { NotificationFacade } from '@core/facades/notification.facade';
import { AuthService } from '@core/services/auth.service';
import { ErrorDialogService } from '@core/services/error-dialog.service';
import { Store } from '@ngxs/store';
import { AuthSelectors } from 'app/auth/store/auth.selectors';
import { Observable, tap } from 'rxjs';

/**
 * Any additional headers will make the API return 403
 */
//TODO: remove the bypass on implementing the auth service
export const AuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  let headers: Record<string, string> = req.body instanceof FormData ? {} : { 'Content-Type': 'application/json' };
  const store = inject(Store);
  const toast = inject(NotificationFacade);
  const userPermissions = store.selectSnapshot(AuthSelectors.getPermissions);
  const globalPermissions = store.selectSnapshot(AuthSelectors.getGlobalPermissions);


  const authService = inject(AuthService);

  const token = authService.getToken();

  if (req.url.indexOf('/auth/') === -1) {
    Object.assign(headers, {
      Authorization: 'Bearer ' + token,
    });
  }

  req = req.clone({
    setHeaders: headers,
    setParams: {},
  });


  // Find if the URL matches a protected endpoint
  const matchedPermission = globalPermissions.find((perm) =>
    Object.values(perm).some((endpoint) => req.url.includes(endpoint))
  );
  if (matchedPermission) {
    const requiredPermissionKey = Object.keys(matchedPermission)[0];

    // Check if the user has this specific permission
    const hasPermission = userPermissions.some(
      (perm: Record<string, string>) =>
        Object.keys(perm)[0] === requiredPermissionKey
    );

    if (!hasPermission) {
      const errorMsg = `You do not have permission to access this resource. Required permission: "${requiredPermissionKey}".`;
      // Throw an HttpErrorResponse so Angular treats it as a failed HTTP call
      toast.error(errorMsg);
      throw new HttpErrorResponse({
        error: errorMsg,
        status: 403,
        statusText: 'Forbidden',
        url: req.url,
      });
    }
    return next(req);
  }
  return next(req);
};
